/*
 * @Descripttion: 路由
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-08-26 20:58:02
 * @LastEditors: hayuu
 * @LastEditTime: 2025-03-25 10:47:15
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/index.vue'),
    meta: { keepAlive: true } // 这个组件会被缓存
  },
  {
    path: '/idCardPrint',
    name: 'idCardPrint',
    component: () => import('../views/idCardPrint/index.vue')
  },
  {
    path: '/id_copy',
    name: 'id_copy',
    component: () => import('../views/idCardPrint/id_copy.vue')
  },
  {
    path: '/img_copy',
    name: 'img_copy',
    component: () => import('../views/selfCopying/img_copy.vue')
  },
  {
    path: '/selfCopying',
    name: 'selfCopying',
    component: () => import('../views/selfCopying/index.vue')
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('../views/guide/index.vue'),
    meta: {
      keepAlive: true,
      isBack: false
    } // 这个组件会被缓存
  },
  {
    path: '/sxzw',
    name: 'sxzw',
    component: () => import('../views/guide/sxzw.vue')
  },
  {
    path: '/simplifyDetail',
    name: 'simplifyDetail',
    component: () => import('../views/guide/simplifyDetail.vue'),
    // meta: {
    //   keepAlive: true,
    // } // 这个组件会被缓存
  },
  {
    path: '/fullDetail',
    name: 'fullDetail',
    component: () => import('../views/guide/fullDetail.vue'),
    // meta: {
    //   keepAlive: true,
    // } // 这个组件会被缓存
  },
  {
    path: '/instantAction',
    name: 'instantAction',
    component: () => import('../views/instantAction/index.vue')
  },
  {
    path: '/instantActionDetail',
    name: 'instantActionDetail',
    component: () => import('../views/instantAction/detail.vue')
  },
  {
    path: '/certificate_copy',
    name: 'certificate_copy',
    component: () => import('../views/instantAction/certificate_copy.vue')
  },
  {
    path: '/jzz_copy',
    name: 'jzz_copy',
    component: () => import('../views/instantAction/jzz_copy.vue')
  },
  {
    path: '/pkz_copy',
    name: 'pkz_copy',
    component: () => import('../views/instantAction/pkz_copy.vue')
  },
  {
    path: '/individualCenter',
    name: 'individualCenter',
    component: () => import('../views/individualCenter/index.vue')
  },
  {
    path: '/sxzwUser',
    name: 'sxzwUser',
    component: () => import('../views/individualCenter/sxzwUser.vue')
  },
  {
    path: '/newsPolicy',
    name: 'newsPolicy',
    component: () => import('../views/newsPolicy/index.vue'),
    meta: {
      keepAlive: true,
    } // 这个组件会被缓存
  },
  {
    path: '/newsPolicyDetail',
    name: 'newsPolicyDetail',
    component: () => import('../views/newsPolicy/detail.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service/index.vue'),
    children: [
      {
        path: 'ybPersonal',
        name: 'ybPersonal',
        component: () => import('../views/service/ybPersonal.vue')
      },
      {
        path: 'ybAccount',
        name: 'ybAccount',
        component: () => import('../views/service/ybAccount.vue')
      },
      {
        path: 'ylPersonal',
        name: 'ylPersonal',
        component: () => import('../views/service/ylPersonal.vue')
      },
      {
        path: 'ylSchedule',
        name: 'ylSchedule',
        component: () => import('../views/service/ylSchedule.vue')
      },
      {
        path: 'ylPay',
        name: 'ylPay',
        component: () => import('../views/service/ylPay.vue')
      },
      {
        path: 'foodProduction',
        name: 'foodProduction',
        component: () => import('../views/service/foodProduction.vue')
      },
    ]
  },
  {
    path: '/questionsAnswers',
    name: 'questionsAnswers',
    component: () => import('../views/questionsAnswers/questionsAnswers.vue')
  },
  {
    path: '/deepceek',
    name: 'questionsAnswers',
    component: () => import('../views/questionsAnswers/deepceek.vue')
  },
  {
    path: '/declare',
    name: 'declare',
    component: () => import('../views/guide/declare/index.vue')
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/error/index.vue')
  },
  {
    path: '/exploit',
    name: 'exploit',
    component: () => import('../views/exploit/index.vue')
  },
  {
    path: '/draw',
    name: 'draw',
    component: () => import('../views/draw/index.vue')
  },
  {
    path: '/deposit',
    name: 'deposit',
    component: () => import('../views/deposit/index.vue')
  },
]

const router = new VueRouter({
  routes,
})

export default router
